import { isEqual } from '@mcfe/tools';

// 统一处理营养成分表
const mapNutritions = (nutritions) => nutritions.map((item) => ({
    nutritions: {
        headers: item.nutritions.headers,
        items: item.nutritions.items.map((ite) => ({
            details: ite.details,
            itemName: ite.itemName,
            parentItem: ite.parentItem,
        })),
    },
    productName: item.productName,
}));

// 统一处理配料表
const mapIngredients = (ingredients) => ingredients.map((item) => ({
    productName: item.productName,
    ingredients: item.ingredients,
}));

// 是否覆盖提示
const coverConfirm = (that) => new Promise((resolve, reject) => {
    that.$mc.confirm({
        title: '提示',
        message: '系统识别营养成分表/配料表内容信息与填写不一致，是否覆盖现有文本信息',
        width: '430px',
        okButtonText: '是',
        cancelButtonText: '否',
        closable: false,
        showCancelButton: true,
        onOk: () => {
            resolve();
        },
        onCancel: () => {
            reject();
        },
    });
});

// 检查营养成分和成分是否发生变化
export const checkNutritionAndIngredientChanges = (that, { nutritionsObj, ingredientsObj }, type) => {
    const isChanged = {
        nutritions: !isEqual(mapNutritions(nutritionsObj.nutritions), mapNutritions(nutritionsObj.backupsNutritions)),
        ingredients: !isEqual(mapIngredients(ingredientsObj.ingredients), mapIngredients(ingredientsObj.backupsIngredients)),
    };
    const shouldConfirm = type === 'all'
        ? isChanged.nutritions || isChanged.ingredients
        : isChanged[type];

    // 如果需要确认操作，调用 coverConfirm 方法
    if (shouldConfirm) {
        return coverConfirm(that);
    }
    // 如果不需要确认操作，返回一个 resolved 的 Promise
    return Promise.resolve();
};

// 提示用户是否识别营养成分表和配料表
export const isIdentifyConfirm = (that) => new Promise((resolve, reject) => {
    that.$mc.confirm({
        title: '提示',
        message: '当前未识别营养成分配料表信息，请先点击“开始识别”按钮识别，补充营养成分配料表信息后提交',
        width: '430px',
        okButtonText: '开始识别',
        cancelButtonText: '取消',
        closable: false,
        showCancelButton: true,
        onOk: () => {
            resolve();
        },
        onCancel: () => {
            reject();
        },
    });
});

// 提示用户营养成分表和配料表未填写
const notFilledConfirm = (that, refer) => new Promise((resolve, reject) => {
    that.$mc.confirm({
        title: '提示',
        message: '系统检测到图片中包含营养成分配料表信息，此部分信息尚未填写，请返回补充填写，否则有被驳回的风险',
        width: '430px',
        okButtonText: '确认提交',
        cancelButtonText: '返回填写',
        closable: false,
        showCancelButton: true,
        onOk: () => {
            resolve(refer);
        },
        onCancel: () => {
            reject();
        },
    });
});

// 检查营养成分配料表
export const checkNutritionAndIngredients = (that, {
    refer, nutritions, ingredients, isNutEmpty, isIngEmpty,
}) => {
    const isNutNull = nutritions.some((item) => (item.nutritions?.items || []).some((items) => (items.details || []).some((ite) => ite)));
    const isIngNull = ingredients.some((item) => item.ingredients?.[0]);
    // 有营养成分表但是用户没有填写 或者 有配料表但是用户没有填写
    if ((isNutNull && !isNutEmpty) || (isIngNull && !isIngEmpty)) {
        return notFilledConfirm(that, refer);
    }
    return Promise.resolve(true);
};

// 将营养成分表的表头进行映射
const mapNutritionHeaders = (resHeaders, itemHeaders) => itemHeaders.map((header, index) => (index === 0 ? '项目' : resHeaders[index] || ''));

// 将营养成分表的详细信息进行映射
const mapNutritionDetails = (resDetails, itemDetails) => itemDetails.map((detail, index) => resDetails[index] || '');

// 将营养成分表的项目进行映射
const mapNutritionItems = (resItems, itemDetails) => resItems.map((item) => ({
    ...item,
    details: mapNutritionDetails(item.details, itemDetails),
}));

// 处理营养成分表信息
export const handleNutritions = (resIngredients, formNutritions) => formNutritions.map((item, index) => {
    const resIngredient = resIngredients[index];
    if (!resIngredient) return null;
    return {
        ...resIngredient,
        nutritions: {
            ...resIngredient.nutritions,
            headers: mapNutritionHeaders(resIngredient.nutritions.headers, item.nutritions.headers),
            items: mapNutritionItems(resIngredient.nutritions.items, item.nutritions.items[0].details),
        },
    };
}).filter(Boolean);

export const isNutritionsContentConfirm = (that) => new Promise((resolve, reject) => {
    that.$mc.confirm({
        title: '提示',
        message: '当前未识别营养成分含量',
        width: '430px',
        okButtonText: '开始识别',
        cancelButtonText: '取消',
        closable: false,
        showCancelButton: true,
        onOk: () => {
            resolve();
        },
        onCancel: () => {
            reject();
        },
    });
});
